import { TextLinkProps } from '../components/link';

export const isTextLinkProps = (linkProps: unknown): linkProps is TextLinkProps =>
  [
    'hyperlink-100',
    'hyperlink-200',
    'button-primary',
    'button-secondary',
    'button-ghost',
    'hyperlink-standalone',
    'hyperlink-legal'
  ].includes((linkProps as TextLinkProps)?.variant) &&
  typeof (linkProps as TextLinkProps)?.href === 'string' &&
  (linkProps as TextLinkProps)?.linkText !== undefined;

export const isTextLinkPropsWithoutVariant = (linkProps: unknown): linkProps is Omit<TextLinkProps, 'variant'> =>
  typeof (linkProps as TextLinkProps)?.href === 'string' && (linkProps as TextLinkProps)?.linkText !== undefined;
